import { useMemo } from 'react';
import type { CalendarEvent, CalendarRow, Period, PromoTypeLegendItem } from '../../../../types/calendar';

export function usePromoTypeLegend(dataSource: CalendarRow[], periods: Period[]): PromoTypeLegendItem[] {
    return useMemo(() => {
        const typeMap = new Map<string, { color: string; label: string }>();
        const collectFromRows = (rows: CalendarRow[]) => {
            rows?.forEach((row) => {
                periods.forEach((p) => {
                    const events = row[p.period_start_date] as CalendarEvent[] | undefined;
                    events?.forEach((evt) => {
                        if (evt.colorType && !typeMap.has(evt.colorType)) {
                            typeMap.set(evt.colorType, { color: evt.color, label: evt.colorLabel });
                        }
                    });
                });
                if (row.children) collectFromRows(row.children);
            });
        };
        collectFromRows(dataSource);

        return Array.from(typeMap.entries()).map(([colorType, { color, label }]) => ({
            type: colorType,
            label,
            color,
        }));
    }, [dataSource, periods]);
}
